import React from 'react';
import { Pie } from 'react-chartjs-2';
import { tinycolor } from '@ctrl/tinycolor';
import _ from 'lodash';

class VolumeByReferenceChart extends React.Component {
    render() {
        const labels = _.map(this.props.data, x => x.product_reference);

        const colours = _.map(this.props.data, (x, i, l) => ({
            h: ((360.0 / l.length) * i), //random hue
            s: 0.9,
            l: 0.5,
            a: 1
        })
        );

        return (
            <Pie
                data={{
                    labels: labels,
                    datasets: [
                        {
                            label: 'Qty',
                            data: _.map(this.props.data, x => x.total),
                            backgroundColor: colours.map(x => tinycolor(x).toRgbString()),
                            hoverBackgroundColor: colours.map(x => tinycolor({ ...x, s: 0.8, l: 0.45 }).toRgbString()),
                        }
                    ]
                }}
            />
        );
    }
}


export default VolumeByReferenceChart;
